module.exports = __webpack_public_path__ + "3b3f60c753a1eb8ed9a45336b5a7cdc6.png";